

const rocketData = [
    {
        id: 1,
      title: "ISS",
      content: "300-1500km",
      description:
        "Used for astronomical observations, capturing stunning images of the universe.",
    image : "https://cdn.pixabay.com/photo/2017/09/14/15/41/spaceship-2749363_960_720.png"
    },
    {
        id:2,
      title: "PATHFINDER",
      content: "500-1500km",
      description:
        "it's a habitable artificial satellite orbiting Earth and serves as a space environment research laboratory",
    image: "https://cdn.pixabay.com/photo/2017/10/11/14/57/spaceship-2841277_1280.png"
    },
    {
        id : 3,
      title: "SCKN-X",
      content: "300-1500km",
      description:
        "Part of the Global Positioning System (GPS) used for navigation.",
      image: "https://cdn.pixabay.com/photo/2022/10/22/21/17/a-wing-7540055_1280.png"
          },
  ];

export default rocketData